import { Col, Container, Row } from "reactstrap";
import { BrowseCarService } from "../../../../constants";
import { ServiceData } from "../../../../data/demo/CarDemo1";
import { dynamicSvg, Image } from "../../../../utils";
import CommonHeader from "../../../home/common/CommonHeader";

const CarCategory = () => {
  return (
    <section className="job-category-section car-about-category section-b-space">
      <Container>
        <CommonHeader contentClass="text-black" title={BrowseCarService} content="Search and connect with the right candidates faster." headClass="title-style-3 text-center" />
        <Row className="gy-4">
          {ServiceData.map((service, index) => (
            <Col xl="3" lg="3" sm="6" key={index}>
              <div className="category-box">
                <Image src={dynamicSvg("job/job-box/dots-category.svg")} alt="dots-category" className="img-fluid dot-img" />
                <div className="category-icon">{service.icon}</div>
                <div className="category-title">
                  <h4>{service.title}</h4>
                  <p>{service.text}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default CarCategory;
